import { gql } from "graphql-tag";

/**
 * Fetches taxes with their Ids
 *
 * variable example
 * { "ids": "(id,in,48,49)" }
 */
export const GET_Taxes = gql`
  query GetTaxes($ids: String!) {
    taxes: TaxList(where: $ids) {
      id: Id
      name: Name
      taxNumber: TaxNumber
      includedInPrice: IncludedInPrice
      rateMiliValue: RateMiliValue
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
